const initialState = {
    "paso": 0,
    "completo": false,
    "hashOne": null,
    "hashTwo": null,
    "apaterno": "",
    "amaterno": "",
    "nombres": "",
    "email": "",
    "fechaNacimiento": "",
    "fechaNacimientoDate": "",
    "genero": "masculino",
    "ladaCelular": "",
    "telCelular": "",
    "rfc": "",
    "poliza": "",
    "password": "",
    "pregunta1": "",
    "pregunta2": "",
    "respuesta1": "",
    "respuesta2": "",
    "mediosElectronicos": false,
    "datosPersonales": false
}

export function registroFamiliarRdc(state = initialState, action) {
    
    switch (action.type) {
        case "REGISTRO_FAMILIAR_PASO": 
            return {...state,
                "paso": action.paso
            };
        case "REGISTRO_FAMILIAR_COMPLETO":
            return {...state,
                "completo": action.completo
            };
        case "REGISTRO_FAMILIAR_HASH":
            return {...state,
                "hashOne": action.hashOne,
                "hashTwo": action.hashTwo
            };
        case "REGISTRO_FAMILIAR_EMAIL":
            return {...state,
                "email": action.email
            }; 
        case "REGISTRO_FAMILIAR_DATOS":
            return {...state,
                "apaterno": action.apaterno,
                "amaterno": action.amaterno,
                "nombres": action.nombres,
                "email": action.email,
                "fechaNacimiento": action.fechaNacimiento,
                "fechaNacimientoDate": action.fechaNacimientoDate,
                "genero": action.genero,
                "ladaCelular": action.ladaCelular,
                "telCelular": action.telCelular,
                "rfc": action.rfc,
                "poliza": action.poliza
            };
        case "REGISTRO_FAMILIAR_SEGURIDAD":
            return {...state,
                "password": action.password,
                "pregunta1": action.pregunta1,
                "respuesta1": action.respuesta1,
                "pregunta2": action.pregunta2,
                "respuesta2": action.respuesta2
            };
        case "REGISTRO_FAMILIAR_CONTRATO_ME":
            return {...state,
                "mediosElectronicos": action.mediosElectronicos,
            };
        case "REGISTRO_FAMILIAR_CONTRATO_DP":
            return {...state,
                "datosPersonales": action.datosPersonales,
            };
        case "REGISTRO_FAMILIAR_LIMPIAR":
            return {...state,
                "paso": 0,
                "completo": false,
                "hashOne": null,
                "hashTwo": null,
                "apaterno": "",
                "amaterno": "",
                "nombres": "",
                "email": "",
                "fechaNacimiento": "",
                "fechaNacimientoDate": "",
                "genero": "masculino",
                "ladaCelular": "",
                "telCelular": "",
                "rfc": "",
                "poliza": "",
                "password": "",
                "pregunta1": "",
                "pregunta2": "",
                "respuesta1": "",
                "respuesta2": "",
                "mediosElectronicos": false,
                "datosPersonales": false                
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/registro-familiar/reducer.js